import type { UserProfiles, UserRoles } from "@shared/models";

export interface User {
  id: number;
  lastname: string;
  firstname: string; // I warned the backend about this misspelling
  email: string;
  role: UserRoles;
  profile: UserProfiles;
  company?: string
}
